import { PageId } from 'constants/pages'
import { TIdToPageConfigMap } from 'models/common.model'
import { THEMES } from 'root-constants'

type TWoofzWa1PageConfigKeys =
  | PageId.SUBSCRIPTIONS_WA1
  | PageId.CANCEL_OFFER_WA1
  | PageId.DOWNLOAD_WA1

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_WA1: Pick<
  TIdToPageConfigMap,
  TWoofzWa1PageConfigKeys
> = {
  [PageId.SUBSCRIPTIONS_WA1]: {
    id: PageId.SUBSCRIPTIONS_WA1,
  },
  [PageId.CANCEL_OFFER_WA1]: {
    hasHeader: false,
    id: PageId.CANCEL_OFFER_WA1,
  },
  [PageId.DOWNLOAD_WA1]: {
    hasHeader: true,
    id: PageId.DOWNLOAD_WA1,
    theme: THEMES.POLICY,
  },
}
